import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Invalidate all workplace request category queries.
 * Use after creating, updating, or deleting categories. Also invalidates request types,
 * whose responses embed the owning category.
 */
export const useInvalidateWorkplaceRequestCategories = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: ["workplaceRequestCategories"]
    });
    await queryClient.invalidateQueries({
      queryKey: ["workplaceRequestTypes"]
    });
  }, [queryClient]);
};
